import { render, staticRenderFns } from "./UrlRender.vue?vue&type=template&id=79b1a8e0&"
import script from "./UrlRender.vue?vue&type=script&lang=ts&"
export * from "./UrlRender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports